import * as React from "react";
const OfflineIcon = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.375 14.2188H5.625C3.90625 14.2188 2.65625 12.9688 2.65625 11.25V3.75C2.65625 2.03125 3.90625 0.78125 5.625 0.78125H9.375C11.0938 0.78125 12.3438 2.03125 12.3438 3.75V11.25C12.3438 12.9688 11.0938 14.2188 9.375 14.2188ZM5.625 1.71875C4.21875 1.71875 3.59375 2.7375 3.59375 3.75V11.25C3.59375 12.2625 4.21875 13.2812 5.625 13.2812H9.375C10.7812 13.2812 11.4062 12.2625 11.4062 11.25V3.75C11.4062 2.7375 10.7812 1.71875 9.375 1.71875H5.625Z"
      fill="#FF6A4B"
    />
    <path
      d="M11.875 10.475H3.125C2.86875 10.475 2.65625 10.2625 2.65625 10.0062C2.65625 9.74998 2.86875 9.53748 3.125 9.53748H11.875C12.1313 9.53748 12.3438 9.74998 12.3438 10.0062C12.3438 10.2625 12.1313 10.475 11.875 10.475Z"
      fill="#FF6A4B"
    />
    <path
      d="M1.25 12.9688C0.99375 12.9688 0.78125 12.7563 0.78125 12.5V2.5C0.78125 2.24375 0.99375 2.03125 1.25 2.03125C1.50625 2.03125 1.71875 2.24375 1.71875 2.5V12.5C1.71875 12.7563 1.50625 12.9688 1.25 12.9688Z"
      fill="#FF6A4B"
    />
    <path
      d="M13.75 12.9688C13.4938 12.9688 13.2812 12.7563 13.2812 12.5V2.5C13.2812 2.24375 13.4938 2.03125 13.75 2.03125C14.0063 2.03125 14.2188 2.24375 14.2188 2.5V12.5C14.2188 12.7563 14.0063 12.9688 13.75 12.9688Z"
      fill="#FF6A4B"
    />
  </svg>
);
export default OfflineIcon;
